/* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
(function(a){a.fn.prepareTransition=function(){return this.each(function(){var b=a(this);b.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd",function(){b.removeClass("is-transitioning")});var c=["transition-duration","-moz-transition-duration","-webkit-transition-duration","-o-transition-duration"];var d=0;a.each(c,function(a,c){d=parseFloat(b.css(c))||d});if(d!=0){b.addClass("is-transitioning");b[0].offsetWidth}})}})(jQuery);

/* replaceUrlParam - http://stackoverflow.com/questions/7171099/how-to-replace-url-parameter-with-javascript-jquery */
function replaceUrlParam(e,r,a){var n=new RegExp("("+r+"=).*?(&|$)"),c=e;return c=e.search(n)>=0?e.replace(n,"$1"+a+"$2"):c+(c.indexOf("?")>0?"&":"?")+r+"="+a};

/*============================================================================
  Money Format
  - Shopify.format money is defined in option_selection.js.
    If that file is not included, it is redefined here.
==============================================================================*/
if ((typeof Shopify) === 'undefined') { Shopify = {}; }
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function(cents, format) {
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || this.money_format);

    if (typeof cents == 'string') {
      cents = cents.replace('.','');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}

// Timber functions
window.timber = window.timber || {};

timber.cacheSelectors = function () {
  timber.cache = {
    // General
    $html                    : $('html'),
    $body                    : $(document.body),

    // Navigation
    $navigation              : $('#AccessibleNav'),
    $mobileSubNavToggle      : $('.mobile-nav__toggle'),

    // Collection Pages
    $changeView              : $('.change-view'),

    // Product Page
    $productImage            : $('#ProductPhotoImg'),
    $thumbImages             : $('#ProductThumbs').find('a.product-single__thumbnail'),

    // Customer Pages
    $recoverPasswordLink     : $('#RecoverPassword'),
    $hideRecoverPasswordLink : $('#HideRecoverPasswordLink'),
    $recoverPasswordForm     : $('#RecoverPasswordForm'),
    $customerLoginForm       : $('#CustomerLoginForm'),
    $passwordResetSuccess    : $('#ResetSuccess')
  };
};

timber.init = function () {
 
  timber.cacheSelectors();
  timber.accessibleNav();
 
  timber.mobileNavToggle();
  timber.productImageSwitch();
  timber.responsiveVideos();
  timber.collectionViews();
  timber.loginForms();
};

timber.accessibleNav = function () {
  var $nav = timber.cache.$navigation,
      $allLinks = $nav.find('a'),
      $topLevel = $nav.children('li').find('a'),
      $parents = $nav.find('.site-nav--has-dropdown'),
      $subMenuLinks = $nav.find('.site-nav__dropdown').find('a'),
      activeClass = 'nav-hover',
      focusClass = 'nav-focus';

  // Mouseenter
  $parents.on('mouseenter touchstart', function(evt) {
    var $el = $(this);

    if (!$el.hasClass(activeClass)) {
      evt.preventDefault();
    }

    showDropdown($el);
  });

  // Mouseout
  $parents.on('mouseleave', function() {
    hideDropdown($(this));
  });

  $subMenuLinks.on('touchstart', function(evt) {
    // Prevent touchstart on body from firing instead of link
    evt.stopImmediatePropagation();
  });

  $allLinks.focus(function() {
    handleFocus($(this));
  });

  $allLinks.blur(function() {
    removeFocus($topLevel);
  });

  // accessibleNav private methods
  function handleFocus ($el) {
    var $subMenu = $el.next('ul'),
        hasSubMenu = $subMenu.hasClass('sub-nav') ? true : false,
        isSubItem = $('.site-nav__dropdown').has($el).length,
        $newFocus = null;

    // Add focus class for top level items, or keep menu shown
    if (!isSubItem) {
      removeFocus($topLevel);
      addFocus($el);
    } else {
      $newFocus = $el.closest('.site-nav--has-dropdown').find('a');
      addFocus($newFocus);
    }
  }

  function showDropdown ($el) {
    $el.addClass(activeClass);

    setTimeout(function() {
      timber.cache.$body.on('touchstart', function() {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown ($el) {
    $el.removeClass(activeClass);
    timber.cache.$body.off('touchstart');
  }

  function addFocus ($el) {
    $el.addClass(focusClass);
  }

  function removeFocus ($el) {
    $el.removeClass(focusClass);
  }
};

 

timber.mobileNavToggle = function () {
  timber.cache.$mobileSubNavToggle.on('click', function() {
    $(this).parent().toggleClass('mobile-nav--expanded');
  });
};

timber.getHash = function () {
  return window.location.hash;
};

timber.productPage = function (options) {
  var moneyFormat = options.money_format,
      variant = options.variant,
      selector = options.selector;

  // Selectors
  var $productImage = $('#ProductPhotoImg'),
      $addToCart = $('#AddToCart'),
      $productPrice = $('#ProductPrice'),
      $comparePrice = $('#ComparePrice'),
      $quantityElements = $('.quantity-selector, label + .js-qty'),
      $addToCartText = $('#AddToCartText');

  if (variant) {

    // Update variant image, if one is set
    
//      if (variant.featured_image) {
//                             variant.featured_image;
//                             var r = variant.id,
//                                 a = $(".finsle")
//                                     .find('option[value="' + r + '"]')
//                                     .data("image"),
//                                 l = $(".product_big_slide")
//                                     .find('.item[data-ver="' + a + '"]')
//                                     .data("slick-index");
//        console.log($(".product_big_slide").find('.item[data-ver="' + a + '"]').attr("data-slick-index"));
    
//                             $(".product_big_slide").slick("slickGoTo", l, !0);
//                         }

    // Select a valid variant if available
    if (variant.available) {
      // Available, enable the submit button, change text, show quantity elements
      $addToCart.removeClass('disabled').prop('disabled', false);
      $addToCartText.html("In den Warenkorb legen");
      $quantityElements.show();
    } else {
      // Sold out, disable the submit button, change text, hide quantity elements
      $addToCart.addClass('disabled').prop('disabled', true);
      $addToCartText.html("Ausverkauft");
      $quantityElements.hide();
    }

    // Regardless of stock, update the product price
    $productPrice.html( Shopify.formatMoney(variant.price, moneyFormat) + '<span class="inas">inkl. MwSt. </span>');

    // Also update and show the product's compare price if necessary
    if (variant.compare_at_price > variant.price) {
      $comparePrice
        .html(Shopify.formatMoney(variant.compare_at_price, moneyFormat) )
        .show();
    } else {
      $comparePrice.hide();
    }

  } else {
    // The variant doesn't exist, disable submit button.
    // This may be an error or notice that a specific variant is not available.
    // To only show available variants, implement linked product options:
    //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
    $addToCart.addClass('disabled').prop('disabled', true);
    $addToCartText.html("Nicht verfügbar");
    $quantityElements.hide();
  }
};

timber.productImageSwitch = function () {
  if (timber.cache.$thumbImages.length) {
    // Switch the main image with one of the thumbnails
    // Note: this does not change the variant selected, just the image
    timber.cache.$thumbImages.on('click', function(evt) {
      evt.preventDefault();
      var newImage = $(this).attr('href');
      timber.switchImage(newImage, null, timber.cache.$productImage);
    });
  }
};

timber.switchImage = function (src, imgObject, el) {
  // Make sure element is a jquery object
  var $el = $(el);
  $el.attr('src', src);
};

timber.responsiveVideos = function () {
  var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]');
  var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

  $iframeVideo.each(function () {
    // Add wrapper to make video responsive
    $(this).wrap('<div class="video-wrapper"></div>');
  });

  $iframeReset.each(function () {
    // Re-set the src attribute on each iframe after page load
    // for Chrome's "incorrect iFrame content on 'back'" bug.
    // https://code.google.com/p/chromium/issues/detail?id=395791
    // Need to specifically target video and admin bar
    this.src = this.src;
  });
};

timber.collectionViews = function () {
  if (timber.cache.$changeView.length) {
    timber.cache.$changeView.on('click', function() {
      var view = $(this).data('view'),
          url = document.URL,
          hasParams = url.indexOf('?') > -1;

      if (hasParams) {
        window.location = replaceUrlParam(url, 'view', view);
      } else {
        window.location = url + '?view=' + view;
      }
    });
  }
};

timber.loginForms = function() {
  function showRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.show();
    timber.cache.$customerLoginForm.hide();
  }

  function hideRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.hide();
    timber.cache.$customerLoginForm.show();
  }

  timber.cache.$recoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    showRecoverPasswordForm();
  });

  timber.cache.$hideRecoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    hideRecoverPasswordForm();
  });

  // Allow deep linking to recover password form
  if (timber.getHash() == '#recover') {
    showRecoverPasswordForm();
  }
};

timber.resetPasswordSuccess = function() {
  timber.cache.$passwordResetSuccess.show();
};

/*============================================================================
  Drawer modules
  - Docs http://shopify.github.io/Timber/#drawers
==============================================================================*/
timber.Drawers = (function () {
  var Drawer = function (id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.$nodes = {
      parent: $('body, html'),
      page: $('#PageContainer'),
      moved: $('.is-moved-by-drawer')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  };

  Drawer.prototype.init = function () {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.find(this.config.close).on('click', $.proxy(this.close, this));
  };

  Drawer.prototype.open = function (evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to $nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Notify the drawer is going to open
    timber.cache.$body.trigger('beforeDrawerOpen.timber', this);

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$nodes.moved.addClass('is-transitioning');
    this.$drawer.prepareTransition();

    this.$nodes.parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
    this.drawerIsOpen = true;

    // Set focus on drawer
    this.trapFocus(this.$drawer, 'drawer_focus');

    // Run function when draw opens if set
    if (this.config.onDrawerOpen && typeof(this.config.onDrawerOpen) == 'function') {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    // Lock scrolling on mobile
    this.$nodes.page.on('touchmove.drawer', function () {
      return false;
    });

    this.$nodes.page.on('click.drawer', $.proxy(function () {
      this.close();
      return false;
    }, this));

    // Notify the drawer has opened
    timber.cache.$body.trigger('afterDrawerOpen.timber', this);
  };

  Drawer.prototype.close = function () {
    if (!this.drawerIsOpen) { // don't close a closed drawer
      return;
    }

    // Notify the drawer is going to close
    timber.cache.$body.trigger('beforeDrawerClose.timber', this);

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$nodes.moved.prepareTransition({ disableExisting: true });
    this.$drawer.prepareTransition({ disableExisting: true });

    this.$nodes.parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);

    this.drawerIsOpen = false;

    // Remove focus on drawer
    this.removeTrapFocus(this.$drawer, 'drawer_focus');

    this.$nodes.page.off('.drawer');

    // Notify the drawer is closed now
    timber.cache.$body.trigger('afterDrawerClose.timber', this);
  };

  Drawer.prototype.trapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.attr('tabindex', '-1');

    $container.focus();

    $(document).on(eventName, function (evt) {
      if ($container[0] !== evt.target && !$container.has(evt.target).length) {
        $container.focus();
      }
    });
  };

  Drawer.prototype.removeTrapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.removeAttr('tabindex');
    $(document).off(eventName);
  };

  return Drawer;
})();

// Initialize Timber's JS on docready
$(timber.init);

 

var KlaviyoSubscribe=KlaviyoSubscribe||{};
(function(){if(!KlaviyoSubscribe._loaded){KlaviyoSubscribe._loaded=!0;var m={"modal.html":'<div class="klaviyo_modal" style="display:none;"><div class="klaviyo_inner"><a href="#" class="klaviyo_close_modal klaviyo_header_close">&times;</a><form action="" method="POST" novalidate="novalidate" class="klaviyo_subscription_form"><input type="hidden" name="g" value="" /><p class="klaviyo_header"></p><p class="klaviyo_subheader"></p><div class="klaviyo_fieldset"></div><div class="klaviyo_fine_print"></div><div class="klaviyo_form_actions"><button type="submit" class="klaviyo_submit_button"><span></span></button></div><div class="klaviyo_below_submit"></div><div class="error_message" style="display:none;"></div></form><div class="success_message" style="display:none;"></div></div></div>',"flyout.html":'<div class="klaviyo_flyout" style="display:none;"><div class="klaviyo_inner"><div class="klaviyo_topbar" /><a href="#" class="klaviyo_close_flyout klaviyo_header_close">&times;</a><p class="klaviyo_header"></p><p class="klaviyo_subheader"></p><div class="klaviyo_flyout_action"><a href="#"><span /> &raquo;</a></div></div></div>',
"flyout_form.html":'<div class="klaviyo_flyout" style="display:none;"><div class="klaviyo_inner"><div class="klaviyo_topbar" /><a href="#" class="klaviyo_close_flyout klaviyo_header_close">&times;</a><form action="" method="POST" novalidate="novalidate" class="klaviyo_subscription_form"><input type="hidden" name="g" value="" /><p class="klaviyo_header"></p><p class="klaviyo_subheader"></p><div class="klaviyo_inline_fieldset"><input type="email" name="email" placeholder="Your email address" /><button type="submit" class="klaviyo_submit_button"><span></span></button></div><div class="error_message" style="display:none;"></div></form><div class="success_message" style="display:none;"></div></div></div>'},
n=/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,p={$email:"Email Address",$first_name:"First Name",$last_name:"Last Name"},h="klaClosedPopup";KlaviyoSubscribe._debug=-1<document.location.hash.indexOf("#test");KlaviyoSubscribe.has_called_bootstrap=!1;KlaviyoSubscribe.is_requirements_loaded=!1;KlaviyoSubscribe.bootstrap_queue=[];KlaviyoSubscribe.bootstrap_attempts=0;KlaviyoSubscribe.instances={};
KlaviyoSubscribe.isDebugMode=function(){return KlaviyoSubscribe._debug};KlaviyoSubscribe.bootstrap=function(a){KlaviyoSubscribe.has_called_bootstrap||(KlaviyoSubscribe.has_called_bootstrap=!0,KlaviyoSubscribe.loadCss("//a.klaviyo.com/media/css/public/klaviyo_subscribe.css"),KlaviyoSubscribe.fetchRequirements(a))};KlaviyoSubscribe.setHasClosedModalCookieName=function(a){h=a||h};KlaviyoSubscribe.loadScript=function(a,b,c){var d=document.getElementsByTagName("head")[0],e=document.createElement("script");
e.type="text/javascript";e.src=a;d.appendChild(e);KlaviyoSubscribe.log("Loaded JS",a);KlaviyoSubscribe.whenTrue(b,c)};KlaviyoSubscribe.loadCss=function(a){var b=document.getElementsByTagName("head")[0],c=document.createElement("link");c.rel="stylesheet";c.type="text/css";c.href=a;b.appendChild(c);KlaviyoSubscribe.log("Loaded CSS",a)};KlaviyoSubscribe.injectCSS=function(a){var b=document.getElementsByTagName("head")[0],c=document.createElement("style");c.type="text/css";c.styleSheet?c.styleSheet.cssText=
a:c.appendChild(document.createTextNode(a));b.appendChild(c)};KlaviyoSubscribe.whenTrue=function(a,b){var c=0,d=function(){a()?b():(c++,100>c&&setTimeout(d,200))};d()};KlaviyoSubscribe.loadJQuery=function(a){KlaviyoSubscribe.loadScript("//ajax.googleapis.com/ajax/libs/jquery/1.10.2/jquery.min.js",function(){return!!window.jQuery},a)};KlaviyoSubscribe.loadJQueryForm=function(a){KlaviyoSubscribe.loadScript("//cdnjs.cloudflare.com/ajax/libs/jquery.form/3.32/jquery.form.min.js",function(){return!!window.jQuery&&
jQuery.fn.ajaxForm&&jQuery.fn.formSerialize},a)};KlaviyoSubscribe.fetchRequirements=function(a){document.getElementsByTagName("head");a=a||{};if(window.jQuery)jQuery.fn.ajaxForm?KlaviyoSubscribe.processQueue():KlaviyoSubscribe.loadJQueryForm(KlaviyoSubscribe.processQueue);else{var b=function(){KlaviyoSubscribe.log("jQuery loaded.");KlaviyoSubscribe.loadJQueryForm(KlaviyoSubscribe.processQueue)};!0===a.assume_jquery?KlaviyoSubscribe.whenTrue(function(){return!!window.jQuery},b):KlaviyoSubscribe.loadJQuery(b)}};
KlaviyoSubscribe.processQueue=function(){var a,b=function(){for(KlaviyoSubscribe.log("Processing queue.");a=KlaviyoSubscribe.bootstrap_queue.shift();)a();KlaviyoSubscribe.bootstrap_queue.push=function(a){a()}};KlaviyoSubscribe.log("Waiting for DOM to process queue.");jQuery(b);setTimeout(b,5E3)};KlaviyoSubscribe.executeWhenRequirementsLoaded=function(a){KlaviyoSubscribe.bootstrap_queue.push(a)};KlaviyoSubscribe.watchField=function(a,b,c){c=c||{};c.type=c.type||"text";if("email"===b||"$email"===b)c.type=
"email";KlaviyoSubscribe.bootstrap();KlaviyoSubscribe.executeWhenRequirementsLoaded(function(){KlaviyoSubscribe.log("Watching field",a,jQuery(a).length);var d=function(a){a=jQuery.trim($(a.target).val());KlaviyoSubscribe.log("Watch field value",a);if("email"!==c.type||n.test(a)){if(window._learnq&&_learnq.push){var d={};d[b]=a;_learnq.push(["identify",d])}c.callback&&c.callback(b,a)}};if(c.delegate)jQuery(c.delegate).on("change blur",a,d);else jQuery(a).on("change blur",d)})};KlaviyoSubscribe.watchFormSubmission=
function(a,b){b=b||{};b.properties=b.properties||{};b.list&&(KlaviyoSubscribe.bootstrap(),KlaviyoSubscribe.executeWhenRequirementsLoaded(function(){if(b.properties){var c=[];jQuery.each(b.properties,function(a,b){c.push(a)});c.length&&(b.properties.$fields=c.join(","))}KlaviyoSubscribe.log("Watching form",a,jQuery(a).length);var d=function(a){var c=$(a.target);if(window._learnq&&_learnq.identify){var d=_learnq.identify();if(d&&(d=d.$email||d.email)){if(b.if){var e=jQuery(b.if);if(!e.length||(e.is(":checkbox")?
!e.is(":checked"):!e.val())){KlaviyoSubscribe.log("Subscribe if fails",e);return}}d=jQuery.extend({g:b.list,email:d},b.properties);KlaviyoSubscribe.log("Subscribing",d);$.post("//manage.kmail-lists.com/ajax/subscriptions/subscribe",d);KlaviyoSubscribe._logMetric("submitModal",b.list);b.wait_seconds&&(a.preventDefault(),setTimeout(function(){KlaviyoSubscribe.log("Submitting form",c);c.get(0).submit()},1E3*b.wait_seconds))}}};if(b.delegate)jQuery(b.delegate).on("submit",a,d);else jQuery(a).on("submit",
d)}))};KlaviyoSubscribe.attachToForms=function(a,b){b=b||{};var c=b.extra_properties||{};c.$source=c.$source||"$embed";KlaviyoSubscribe.bootstrap();KlaviyoSubscribe.executeWhenRequirementsLoaded(function(){KlaviyoSubscribe.log("Attaching to forms",a,jQuery(a).length);jQuery(a).each(function(){var a=jQuery(this),e=a.data("ajax-submit");e||(e="//manage.kmail-lists.com/ajax/subscriptions/subscribe");a.ajaxForm({url:e,type:"POST",beforeSubmit:function(b,d,e){try{if(!KlaviyoSubscribe.isFormValid(a))return!1}catch(k){return KlaviyoSubscribe.log(k),
a.find(".error_message").show().html(k),a.trigger("klaviyo.subscribe.error"),!1}KlaviyoSubscribe.log("$source",c.$source);KlaviyoSubscribe.normalizeFormFields(b,a,c,e);KlaviyoSubscribe._logMetric("submitModal",b.find(function(a){return"g"===a.name}).value);a.find(".klaviyo_submit_button").attr("disabled",!0)},success:function(c,d,e){a.find(".success_message, .error_message").hide();a.find(".klaviyo_submit_button").attr("disabled",!1);c.success?(KlaviyoSubscribe.setClosedModalCookie(),d=a.find(".success_message").show(),
d.length||(d=a.parent().find(".success_message").show()),window._learnq&&_learnq.push&&(e=a.find('[name="email"]').val())&&(_learnq.push(["identify",{$email:e}]),_learnq.push(["trackActivity"])),b.success_url?window.location=b.success_url:(!0!==b.custom_success_message&&d.html(b.success_message||'<div class="klaviyo_header">Thanks for subscribing!</div><div class="klaviyo_subheader">Check your email for a confirmation message.</div>').end(),!0===b.hide_form_on_success&&(a.find(".klaviyo_field_group input, .klaviyo_form_actions").hide(),
a.is(".klaviyo_horizontal_form")&&a.find(".klaviyo_field_group").hide()),b.success&&b.success(a,c.data),a.trigger("klaviyo.subscribe.success").resetForm())):(KlaviyoSubscribe.log(c.errors),a.find(".error_message").show().html(c.errors.join(" ")),a.trigger("klaviyo.subscribe.error"))}});KlaviyoSubscribe.log("Attached to form",this)})})};KlaviyoSubscribe.attachModalSignUp=function(a){a=a||{};a.pages=a.pages||[];a.excluded_pages=a.excluded_pages||[];a.delay_seconds=a.delay_seconds||.1;a.delay_num_pages=
a.delay_num_pages||0;a.content=a.content||{};a.extra_properties=a.extra_properties||{};a.extra_properties.$source=a.extra_properties.$source||"$modal";a.list&&(KlaviyoSubscribe.bootstrap(),KlaviyoSubscribe.setHasClosedModalCookieName(a.has_closed_modal_cookie_name),KlaviyoSubscribe.executeWhenRequirementsLoaded(function(){var b=KlaviyoSubscribe._buildModalSignUp(a);b.find('[name="g"]').val(a.list);b.appendTo(jQuery("body"));KlaviyoSubscribe.attachToModalForm(b,{list:a.list,pages:a.pages,excluded_pages:a.excluded_pages,
delay:a.delay_seconds,delay_num_pages:a.delay_num_pages,ignore_cookie:a.ignore_cookie,extra_properties:a.extra_properties,custom_success_message:!!a.content.success,success_url:a.success_url,success:function(b){b.hide();a.success&&a.success(b)}})}))};KlaviyoSubscribe._buildModalSignUp=function(a){var b=a.content;b.fields=b.extra_fields||[];-1===jQuery.inArray("$email",b.fields)&&b.fields.unshift("$email");if(b.element)return jQuery(b.element);var c=jQuery(m["modal.html"]).attr("id","k_id_modal").find(".klaviyo_header").html(b.header||
"Interested in our Newsletter?").end().find(".klaviyo_subscription_form").attr("action",a.subscribe_url||"//manage.kmail-lists.com/subscriptions/subscribe").data("ajax-submit",a.ajax_subscribe_url||"//manage.kmail-lists.com/ajax/subscriptions/subscribe").end().find(".klaviyo_submit_button span").html(b.button||"Subscribe").end();b.clazz&&c.addClass(b.clazz);b.styles&&KlaviyoSubscribe.injectCSS(b.styles);!1!==b.subheader&&c.find(".klaviyo_subheader").html(b.subheader||"Stay in the know with news and promotions.");
b.below_submit?c.find(".klaviyo_below_submit").html(b.below_submit):c.find(".klaviyo_below_submit").hide();b.success&&c.find(".success_message").html(b.success);!0===a.ack&&c.append(jQuery('<div class="klaviyo_ack"><a href="http://www.klaviyo.com/?utm_campaign=pbk">Powered by Klaviyo</a></div>'));var d=c.find(".klaviyo_fieldset");jQuery.each(b.fields,function(a,b){"string"===typeof b&&(b={name:b});b.type||(b.type="$email"===b.name?"email":"text");b.label||(b.label=p[b.name]||b.name);a="k_id_modal_"+
b.name;d.append(jQuery('<div class="klaviyo_field_group" />').append(jQuery("<label />").attr("for",a).html(b.label)).append(jQuery("<input />").attr({type:b.type,id:a,name:"$"===b.name[0]?b.name.slice(1):b.name})))});a=b.fine_print||"";b.email_frequency&&(a+=" Our newsletter is delivered to your inbox "+b.email_frequency+".");c.find(".klaviyo_fine_print").html(a);return c};KlaviyoSubscribe.attachToModalForm=function(a,b){b=b||{};b.pages=b.pages||[];b.excluded_pages=b.excluded_pages||[];b.extra_properties=
b.extra_properties||{};b.extra_properties.$source=b.extra_properties.$source||"$modal";void 0===b.delay_seconds&&(b.delay_seconds=void 0===b.delay?2:b.delay);KlaviyoSubscribe.bootstrap();KlaviyoSubscribe.setHasClosedModalCookieName(b.has_closed_modal_cookie_name);KlaviyoSubscribe.executeWhenRequirementsLoaded(function(){var c=jQuery(a);KlaviyoSubscribe.attachToForms(jQuery(a).find(".klaviyo_subscription_form"),b);c.delegate(".klaviyo_close_modal","click",function(a){a.preventDefault();c.hide();KlaviyoSubscribe.setClosedModalCookie();
KlaviyoSubscribe._logMetric("closeModal",b.list)});c.click(function(a){a.currentTarget===a.target&&(c.hide(),KlaviyoSubscribe.setClosedModalCookie())});KlaviyoSubscribe._canShowElem(b)&&jQuery(function(){setTimeout(function(){KlaviyoSubscribe._logMetric("openModal",b.list);c.fadeIn(1E3);c.trigger("klaviyo.modal.show")},1E3*b.delay_seconds)})})};KlaviyoSubscribe.attachFlyoutSignUp=function(a){a=a||{};a.pages=a.pages||[];a.excluded_pages=a.excluded_pages||[];a.delay_scroll=void 0===a.delay_scroll?50:
a.delay_scroll;a.delay_seconds=a.delay_seconds||.1;a.delay_num_pages=a.delay_num_pages||0;a.position=a.position||"right";a.content=a.content||{};a.extra_properties=a.extra_properties||{};a.extra_properties.$source=a.extra_properties.$source||"$flyout";void 0===a.modal_content&&(a.modal_content=a.content);a.list&&(KlaviyoSubscribe.bootstrap(),KlaviyoSubscribe.setHasClosedModalCookieName(a.has_closed_modal_cookie_name),KlaviyoSubscribe.executeWhenRequirementsLoaded(function(){var b=!1===a.modal_content,
c=KlaviyoSubscribe._buildFlyoutSignUp(jQuery.extend({include_form:b},a));c.appendTo(jQuery("body"));if(b){var d=a.success;a.success=function(a){a.hide();KlaviyoSubscribe.setClosedModalCookie();d&&d(a)};a.custom_success_message=!!a.content.success;c.find('[name="g"]').val(a.list);KlaviyoSubscribe.attachToForms(c.find(".klaviyo_subscription_form"),a)}KlaviyoSubscribe.attachToFlyout(c,{list:a.list,pages:a.pages,excluded_pages:a.excluded_pages,delay:a.delay_seconds,delay_scroll:a.delay_scroll,delay_num_pages:a.delay_num_pages,
position:a.position,ignore_cookie:a.ignore_cookie,extra_properties:a.extra_properties,click:function(b){b=KlaviyoSubscribe._buildModalSignUp({content:a.modal_content});b.find('[name="g"]').val(a.list);b.appendTo(jQuery("body"));KlaviyoSubscribe.attachToModalForm(b,{list:a.list,delay:.01,extra_properties:a.extra_properties,success_url:a.success_url,success:function(b){b.hide();a.success&&a.success(b)}})}})}))};KlaviyoSubscribe._buildFlyoutSignUp=function(a){var b=a.content;if(b.element)return jQuery(b.element);
var c=jQuery(m[a.include_form?"flyout_form.html":"flyout.html"]).attr("id","k_id_flyout").find(".klaviyo_header").html(b.header||"Interested in our Newsletter?").end().find(".klaviyo_subscription_form").attr("action",a.subscribe_url||"//manage.kmail-lists.com/subscriptions/subscribe").data("ajax-submit",a.ajax_subscribe_url||"//manage.kmail-lists.com/ajax/subscriptions/subscribe").end().find(".klaviyo_flyout_action a span, .klaviyo_submit_button span").html(b.button||"Subscribe").end();c.addClass("klaviyo_"+
a.position);b.clazz&&c.addClass(b.clazz);b.styles&&KlaviyoSubscribe.injectCSS(b.styles);!1!==b.subheader&&c.find(".klaviyo_subheader").html(b.subheader||"Stay in the know with news and promotions.");b.success&&c.find(".success_message").html(b.success);!0===a.ack&&c.find(".klaviyo_inner").append(jQuery('<div class="klaviyo_ack"><a href="http://www.klaviyo.com/?utm_campaign=pbk">Powered by Klaviyo</a></div>'));return c};KlaviyoSubscribe.attachToFlyout=function(a,b){b=b||{};b.pages=b.pages||[];b.excluded_pages=
b.excluded_pages||[];b.position=b.position||"right";b.extra_properties=b.extra_properties||{};b.extra_properties.$source=b.extra_properties.$source||"$flyout";KlaviyoSubscribe.bootstrap();KlaviyoSubscribe.setHasClosedModalCookieName(b.has_closed_modal_cookie_name);KlaviyoSubscribe.executeWhenRequirementsLoaded(function(){var c=jQuery(a);c.delegate(".klaviyo_close_flyout","click",function(a){a.preventDefault();c.hide();KlaviyoSubscribe.setClosedModalCookie();KlaviyoSubscribe._logMetric("closeModal",
b.list)});c.find(".klaviyo_flyout_action a").click(function(a){a.preventDefault();c.hide();b.click&&b.click()});KlaviyoSubscribe._canShowElem(b)&&jQuery(function(){var a=b.delay_scroll,e=function(){if(!c.data("opened")){var a=b.delay_seconds||b.delay;void 0===a&&(a=2);setTimeout(function(){if(!c.data("opened")){c.data("opened",!0);c.trigger("klaviyo.flyout.show");var a=c.find(".klaviyo_inner"),d=-1<jQuery.inArray(b.position,["left","right","bottom","top"])?b.position:"right",e={},g;e[d]=0;c.css("visibility",
"hidden").show();KlaviyoSubscribe._logMetric("openModal",b.list);"left"===d?g=1.2*-a.width():"right"===d?g=1.2*-a.width():"top"===d?g=1.2*-a.height():"bottom"===d&&(g=1.2*-a.height());a.css(d,g);c.css("visibility","visible");a.animate(e,1E3*(b.slide_seconds||2))}},1E3*a)}};if(!1===a||0===a)e();else{var f=jQuery(document),q=jQuery(window),g="bottom"===a?95:a,k=function(){var a=f.height()-q.height();(0>a?100:100*f.scrollTop()/a)>g&&(e(),f.unbind("scroll",k))};f.scroll(k)}})})};KlaviyoSubscribe.isFormValid=
function(a){var b=a.find('[name="email"]').val();if(!b||!/@/.test(b))throw KlaviyoSubscribe.log("Invalid email address"),"Invalid email address";a.find('input[required="true"], select[required="true"]').each(function(b,d){d=jQuery(d);if(d.is(":radio")||d.is(":checked")){has_value=!!a.find('[name="'+d.attr("name")+'"]:checked').length;if(!has_value)throw KlaviyoSubscribe.log("Required field missing",d.attr("name")),"Required field missing: "+d.attr("name");return has_value}if(!d.val())throw KlaviyoSubscribe.log("Required field missing",
d.attr("name")),"Required field missing: "+d.attr("name");});a.find(".select-date-widget").each(function(a,b){b=jQuery(b);a=KlaviyoSubscribe._int(b.find('[name$="_day"]').val());var c=KlaviyoSubscribe._int(b.find('[name$="_month"]').val());b=KlaviyoSubscribe._int(b.find('[name$="_year"]').val());if(!(isNaN(a)||isNaN(c)||isNaN(b))){switch(c){case 1:case 3:case 5:case 7:case 8:case 10:case 12:if(1<=a&&31>=a)return;case 4:case 6:case 9:case 11:if(1<=a&&30>=a)return;case 2:if(1<=a&&a<=(b%4?28:29))return}KlaviyoSubscribe.log("Invalid date",
b,c,a);throw"Invalid date";}});return!0};KlaviyoSubscribe.normalizeFormFields=function(a,b,c,d){a.push({name:"$timezone_offset",type:"text",value:this._getUtcOffset()});var e=[],f;jQuery.each(c,function(b,c){a.push({name:b,type:"text",value:c});e.push(b)});e.length&&(jQuery.each(a,function(a,b){if("$fields"===b.name)return f=b,!1}),f?f.value+=","+e.join():a.push({name:"$fields",type:"text",value:e.join()}));b.find(".select-date-widget").each(function(b,c){c=jQuery(c);var d=c.find('[name$="_day"]');
b=c.find('[name$="_month"]');var e=c.find('[name$="_year"]');c=d.attr("name");var f=b.attr("name"),g=e.attr("name");d=KlaviyoSubscribe._int(d.val());var h=KlaviyoSubscribe._int(b.val());e=KlaviyoSubscribe._int(e.val());if(!(isNaN(d)||isNaN(h)||isNaN(e))){for(b=0;b<a.length;){var l=a[b];!l||l.name!==c&&l.name!==f&&l.name!==g?b++:a.splice(b,1)}a.push({name:c.replace("_day",""),required:!0,type:"text",value:KlaviyoSubscribe._formatDate(e,h,d)})}})};KlaviyoSubscribe.isCurrentLocationInPatterns=function(a){for(var b=
location.toString(),c=0,d=a.length;c<d;c++)if(KlaviyoSubscribe.patternMatchesUrl(a[c],b))return!0;return!1};KlaviyoSubscribe.patternMatchesUrl=function(a,b){b=b.toLowerCase();if(a===b)return!0;if(-1===a.indexOf("?")){var c=b.indexOf("?");-1!==c&&(b=b.substring(0,c))}if(-1===a.indexOf("*"))return a=a.replace(/\/$/,""),""===a&&(a="/"),b=b.replace(/\/$/,""),a===b?!0:0===a.indexOf("/")?(b=KlaviyoSubscribe.parseDomain(b),""===a?"/"===b:b===a):!1;if(a===b)return!0;if(!a.length)return!1;c=a.replace(/[.+?|()\[\]{}\\]/g,
"\\$&").replace(/\*/g,"(.*?)");c=/\/$/.test(c)?"^"+c+"$":"^"+c+"/?$";c=new RegExp(c,"i");return c.test(b)?!0:a.indexOf("/")?!1:c.test(KlaviyoSubscribe.parseDomain(b))};KlaviyoSubscribe.parseDomain=function(a){return"/"+a.split("//")[1].split("/").splice(1).join("/")};KlaviyoSubscribe.incrPageViews=function(){var a=parseInt(KlaviyoSubscribe._getCookie("klaPages"),10);isNaN(a)&&(a=0);a+=1;KlaviyoSubscribe._setCookie("klaPages",a,31536E6);return a};KlaviyoSubscribe.setClosedModalCookie=function(){KlaviyoSubscribe._setCookie(h,
"1",31536E6)};KlaviyoSubscribe.resetClosedModalCookie=function(){KlaviyoSubscribe._deleteCookie(h)};KlaviyoSubscribe.hasClosedModal=function(){return!!KlaviyoSubscribe._getCookie(h)&&!KlaviyoSubscribe.isDebugMode()};KlaviyoSubscribe._setCookie=function(a,b,c){c=new Date((new Date).getTime()+c);document.cookie=a+"="+b+";expires="+c.toGMTString()+";path=/"};KlaviyoSubscribe._getCookie=function(a){return(a=(new RegExp("(^|;)[ ]*"+a+"=([^;]*)")).exec(document.cookie))?a[2]:""};KlaviyoSubscribe._deleteCookie=
function(a){KlaviyoSubscribe._getCookie(a)&&KlaviyoSubscribe._setCookie(a,"",-1)};KlaviyoSubscribe._getUtcOffset=function(){return(new Date).getTimezoneOffset()/-60};KlaviyoSubscribe._canShowElem=function(a){return a.delay_num_pages&&a.delay_num_pages>KlaviyoSubscribe.incrPageViews()||a.pages.length&&!KlaviyoSubscribe.isCurrentLocationInPatterns(a.pages)||a.excluded_pages.length&&KlaviyoSubscribe.isCurrentLocationInPatterns(a.excluded_pages)?!1:a.ignore_cookie||!KlaviyoSubscribe.hasClosedModal()};
KlaviyoSubscribe._int=function(a){return parseInt(a,10)};KlaviyoSubscribe._formatDate=function(a,b,c){1===c.toString().length&&(c="0"+c);1===b.toString().length&&(b="0"+b);return a+"-"+b+"-"+c};KlaviyoSubscribe.log=function(){window.console&&console.log&&console.log(arguments)};KlaviyoSubscribe._logMetric=function(a,b){};Array.prototype.find||Object.defineProperty(Array.prototype,"find",{value:function(a,b){if(null==this)throw new TypeError('"this" is null or not defined');var c=Object(this),d=c.length>>>
0;if("function"!==typeof a)throw new TypeError("predicate must be a function");for(var e=0;e<d;){var f=c[e];if(a.call(b,f,e,c))return f;e++}}})}})();
KlaviyoSubscribe.attachToForms('#email_signup', {
      hide_form_on_success: true ,
  success_message:"Danke für deine Anmeldung"
    });
KlaviyoSubscribe.attachToForms('#email_signupp', {
      hide_form_on_success: true ,
  success_message:"Danke für deine Anmeldung"
    });

KlaviyoSubscribe.attachToForms('#email_signuppp', {
      hide_form_on_success: true ,
  success_message:"Danke für deine Anmeldung"
    });


KlaviyoSubscribe.attachToForms('#email_signupppp', {
      hide_form_on_success: true ,
  success_message:"Danke für deine Anmeldung"
    });